import { Col, Form, Row } from "antd";
import React from "react";
import PageHeader from "../../../components/pageHeader";

function LockoutNotComplete() {
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Lockout not complete" />
          </Col>
          <Col span={24}>
            <h3>
              Have broker email attorneys office for update and set up time with
              sheriff
            </h3>
          </Col>
          <Col span={24}>
            <h3>Also have staff person drive by home to see if vacant</h3>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default LockoutNotComplete;
